var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0528 48.0142H23.9472C10.7429 48.0142 0 37.2681 0 24.0599V23.9543C0 10.746 10.7429 0 23.9472 0H24.0528C37.2571 0 48 10.746 48 23.9543V24.0599C48 37.2681 37.2571 48.0142 24.0528 48.0142ZM23.9472 1.62523C11.6381 1.62523 1.62475 11.6415 1.62475 23.9543V24.0599C1.62475 36.3726 11.6381 46.3889 23.9472 46.3889H24.0528C36.3619 46.3889 46.3752 36.3726 46.3752 24.0599V23.9543C46.3752 11.6415 36.3619 1.62523 24.0528 1.62523H23.9472Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9841 13.9842L19.9908 19.9908M28.0091 28.0092L34.0158 34.0158M34.0158 13.9842L28.0091 19.9908L33.0099 14.99M13.9841 34.0158L19.9908 28.0092M38.1666 24C38.1666 31.824 31.824 38.1667 23.9999 38.1667C16.1759 38.1667 9.83325 31.824 9.83325 24C9.83325 16.176 16.1759 9.83333 23.9999 9.83333C31.824 9.83333 38.1666 16.176 38.1666 24ZM29.6666 24C29.6666 27.1296 27.1295 29.6667 23.9999 29.6667C20.8703 29.6667 18.3333 27.1296 18.3333 24C18.3333 20.8704 20.8703 18.3333 23.9999 18.3333C27.1295 18.3333 29.6666 20.8704 29.6666 24Z",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.a2c3bb8d9118b2b4990a53610bf9a9ee.svg";
export { ForwardRef as ReactComponent };